/** Alerte d'urgence. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const EmergencyAlertPage = lazy(() => import('./EmergencyAlertPage.js').then((m) => ({ default: m.EmergencyAlertPage })));

export const emergenciesRoutes: AppRoute[] = [{ path: '/urgences/:id', element: <EmergencyAlertPage /> }];
